module.exports = __webpack_public_path__ + "img/arrowRight.d57dbf5e.svg";